import { render } from "./service-catelog.vue?vue&type=template&id=244346af"
import script from "./service-catelog.vue?vue&type=script&lang=js"
export * from "./service-catelog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__